<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="formRef"
        @submit="addInventaire"
        :validation-schema="inventaireSchema"
        :keep-values="valuess">
          <div class="row">
            <div class="col-md-4 mb-3">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                    Type d'inventaire <span class="text-danger">*</span>
                </label>
                <Multiselect
                  :searchable = "true"
                  :options = "['Global', 'Partiel']"
                  v-model = "typeInventaire"
                  placeholder="Sélectionner le type d'inventaire"
                  />
              </div>
            </div>
            <div class="col-md-4 mb-3"  v-if="typeInventaire == 'Partiel'">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                    Magasin <span class="text-danger">*</span>
                </label>
                <Multiselect
                  :options="magasinOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="magasin"
                  placeholder="Sélectionner le magasin"
                  @select="selectMag(magasin)"
                />
              </div>
            </div>
            <div class="col-md-4 mb-3"  v-if="typeInventaire == 'Partiel'">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                    Inventaire Global
                </label>
                <Field v-model="inventaireGlobal" name="inventaireGlobal"  v-slot="{ field }">
                  <Multiselect
                    :options="inventaireOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner un inventaire"
                  />
                </Field>  
              <ErrorMessage name="inventaireGlobal" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de début <span class="text-danger">*</span>
                  </label>
                  <Field name="dateDebut"  :min="minDate"  type="datetime-local" v-model="dateDebut"
                  class="form-control shadow-none fs-md-15 text-black"/>
                </div>
              <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de fin <span class="text-danger">*</span>
                  </label>
                  <Field name="dateFin"  :min="dateDebut" type="datetime-local"  v-model="dateFin"  
                  class="form-control shadow-none fs-md-15 text-black"/>
                </div>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
          
            <div class="col-md-4 mb-3">
            <div class="form-group">
              <label class="d-block text-black fw-semibold mb-10">
                Motif
              </label>
              <Field
                v-model="motif"
                name="motif"
                as="textarea"
                cols="15"
                rows="1"
                placeholder="Entrer le motif"
                v-slot="{ field }"
                class="form-control shadow-none rounded-0 text-black">
                <textarea class="form-control shadow-none rounded-0 text-black" cols="1"
                  v-model="field.value"
                ></textarea>
              </Field>
              <ErrorMessage name="motif" class="text-danger" />
            </div>
          </div>
          <div class="row mb-2">
            <div class="border border-primary mb-10">
              <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                style="background-color: #0a59a4">
                <div class="col-md-7">
                  <h3 class="fs-4 text-white">
                    Equipes de l'inventaire
                  </h3>
                </div>
                <div class="col-md-5">
                  <div class="d-flex float-end">
                    <button
                      class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                      type="button" :class="{ 'cursor-not-allowed': isDisables }" :disabled="isDisables"
                      @click="addRowEquipe()">
                      <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                      Ajouter une equipe
                    </button>
                    <router-link to="/liste-mouvements"></router-link>
                  </div>
                </div>
              </div>
              <div>
                <div class="row d-flex align-items-center justify-content-between mt-10">
                  
                  <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Personnels <span class="text-danger">*</span>
                </label>  
                </div>
              </div>
              <div class="col-md-4">
                    <label class="d-block text-black fw-semibold mb-10">
                      Role<span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-4">
                    <label class="d-block text-black fw-semibold mb-10">
                      Actions
                    </label>
                  </div>
                </div>
                <hr class="mt-0" />
                <div class="row" v-for="(equipe, index) in equipes" :key="index">
                  <div class="col-md-4 mb-2">
                    <div class="form-group ">
                    <Multiselect 
                    :options="personnelOptions" 
                    :searchable="true" 
                    :multiple="false"
                    v-model="equipe.user"
                    placeholder="Sélectionner le personnel"/>
                    <div class="text-danger" v-if="valideteRowEquipe(equipe.user)"></div>
                    <div class="text-danger" v-if="validateDupliacatEquipe(equipe.user)">Ce personnel a été déjà selectionné</div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-2">
                    <div class="form-group ">
                      <Multiselect 
                      :options="roleOptions" 
                      :searchable="true" 
                      :multiple="false"
                      v-model="equipe.role"
                      placeholder="Choisir le role"/>
                      <span class="invalid-feedback" v-if="valideteRowEquipe(equipe.role)"></span>
                    </div>
                  </div>
                  <div class="col-md-4 mb-2">
                      <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                      @click="removeRowEquipe(index)">
                      <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                      </button>
                </div> 
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="typeInventaire == 'Partiel'">
            <div class="border border-primary mb-10">
              <div class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                <div class="col-md-7">
                  <h4 class="fs-4 text-white">Produits</h4>
                </div>
                <div class="col-md-5">
                  <div class="d-flex float-end">
                    <button
                      class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                      type="button"
                      :class="{ 'cursor-not-allowed': isDisable }"
                      :disabled="isDisable"
                      @click="addRowProduit()">
                      <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i
                      >Ajouter un produit
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <!-- Produit -->
                  <div class="row mt-10">
                    <div class="col-md-7">
                      <label
                        class="d-block text-black fw-semibold">
                        Produit
                        <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-10" >
                        Stock Logique
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label  class="d-block text-black fw-semibold mb-10" >
                        Stock Fiche
                      </label>
                    </div>
                    <div class="col-md-1">
                      <label class="d-block text-black fw-semibold mb-10">
                        Action
                      </label>
                    </div>
                    <hr class="mt-0" />
                  </div>
                  <div
                    class="row gx-2 gy-0" v-for="(produit, produitIndex) in produits" :key="produitIndex">
                      <div class="col-md-7 mb-2">
                        <div class="form-group ">
                          <Multiselect
                            :options="produitOptions"
                            :searchable="true"
                            track-by="label"
                            label="label"
                            v-model="produit.produit"
                            placeholder="Sélectionner le produit"
                            @select="selectProd(produit.produit, produit,produitIndex)"
                          />
                          <div class="invalid-feedback" v-if="validateRowProduit(produit.produit)" >
                              Le produit est obligatoire.
                          </div>
                          <div class="text-danger" v-if="validateDupliacatProduit(produit.produit)" >
                              Ce produit a été déja selectionné
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div
                          class="form-group ">
                          <input
                            type="number"
                            v-model="produit.qtiteLogique"
                            :class="
                              validateRowProduit(produit.qtiteLogique)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black'"
                            placeholder="Entrer la quantité"
                          />
                          <div
                            v-if="validateRowProduit(produit.qtiteLogique)"
                            class="invalid-feedback">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group">
                          <input
                            v-model="produit.qtiteFiche"
                            type="number"
                            :class="
                                validateRowProduit(produit.qtiteFiche)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                : 'form-control shadow-none fs-md-15 text-black'"
                            placeholder="Entrer la quantité"/>
                          <div
                            v-if="validateRowProduit(produit.qtiteFiche)"
                            class="invalid-feedback">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-1 mb-2">
                        <button
                          class="btn btn-danger transition border-0 pb-2 ps-8 pe-8"
                          type="button"
                          @click="removeRowProduit(produitIndex)">
                          <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button
                class="btn btn-success me-3"
                type="submit"  ref="submitButton"
                :disabled="(typeInventaire=='Global')? isDisables:isDisable"
                :class="{ 'cursor-not-allowed': (typeInventaire=='Global')? isDisables:isDisable }">
                Enregistrer
              </button>
              <button
                class="btn btn-primary me-3"
                type="button"
                :disabled="isDisable"
                @click="Soumettre()"
                :class="{ 'cursor-not-allowed': isDisable }">
                 Enregistrer et Soumettre
              </button>
              <router-link to="/inventaires/liste-inventaires"  class="btn btn-danger" ><i class="fa fa-trash-o lh-1 me-1 position-relative top-2" ></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from "vue";
import { Form, Field, ErrorMessage, useFieldArray } from "vee-validate";
import { error, success, suppression } from "@/utils/utils";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import { Inventaire } from "@/models/Inventaire";

import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import { option } from "@/composables/common/animationView";
import Swal from "sweetalert2";

export default defineComponent({
  name: "EditeFicheInventaire",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const inventaireSchema = Yup.object().shape({
      dateDebut: Yup.date().typeError('Entrer une date valide').required('La date de debut est obligatoire'),
      dateFin: Yup.string().typeError('Entrer une date valide').required('La date de fin est obligatoire'),
      motif: Yup.string().notRequired(),
      inventaireGlobal : Yup.string().notRequired()
    });

    const route = useRoute();
    const submitButton = ref(null);
    const inventaireForm = ref<Inventaire | null>(null);
    const router = useRouter();
    const inventaireOptions = ref([]);
    const magasinOptions = ref([]);
    const produitOptions = ref([]);
    const personneOptions = ref([]);
    const magasin = ref();
    const inventaireGlobal = ref();
    const typeInventaire= ref('Global');
    const formRef = ref(null);
    const isDisable = ref(true);
    const produits = reactive([
    ]);

const addRowProduit = () => {
  fetchDataOption();
  produits.push({
    id:"",
    produit: '',
    qtiteLogique: 0,
    qtiteFiche:0,
  });
};


const removeRowProduit = (index) => {
    const id = produits[index].id as number;
    if (id) {
        suppression(id,produits,'procondmag/inventaire','le personnel');
    }else{
      produits.splice(index,1)
    }
};

const selectMag = (selectedMagasin) => {
  console.log(selectedMagasin,"selectedMagasinselectedMagasinselectedMagasin")
  if(selectedMagasin != null && typeInventaire.value=="Partiel" && selectedMagasin != undefined){
    //fetchProduits(selectedMagasin.split("|")[0]);
      if(selectedMagasin.split("|")[0]){
        isDis.value=false;
      }else{
        isDis.value=true;
      }
  }
};

const produitIds =ref([]);

const selectProd = (selectedProduit, produit,index) => {
  produit.produit = selectedProduit;
  if(selectedProduit){
    produitIds.value[index]= selectedProduit.split('|')[0];
    fetchDataOption()
   // calculEcart(produit);
  }
};


// watch(
//   () => produits,
//   (newProduits) => {
//     newProduits.forEach(produit => {
//       calculEcart(produit);
//     });
//     disabledButom.value = (typeInventaire.value == 'Partiel')? isDisable.value:isDisables.value ; 
//   },
//   { deep: true }
// );


const validateRowProduit = (e) => {
  return e === '' || e == null || e < 0;
};

const validateDupliacatProduit = (e) => {
  console.log(produits.filter((element) => element.produit === e).length > 1,"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
  return produits.filter((element) => element.produit === e).length > 1;
};


const validateDupliacatEquipe = (e) => {
 console.log(equipes.filter((element) => element.user === e).length > 1,"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
  return equipes.filter((element) => element.user === e).length > 1;
};


watch(
  produits,
  (newValue) => {
    isDisable.value =newValue.some(
      (produit) =>
        produit.produit === '' || newValue.filter((element) => element.produit === produit.produit).length > 1
        //  produit.qtiteFiche >= 0 ||
        //  produit.qtitePhysique >= 0 ||
        //  produit.qtiteLogique >= 0 
    );
  },
  { deep: true }
);


    onMounted(async () => {
      const id = route.params.id as string;
      fetchMagasins();
      fetchInventaire();
      getAllRoles();
      getAllPersonnels()
      fetchProduits();
      await getAllInventaireById(id);
    });

    
    const roleOptions=ref([]);
    const motif= ref("");
    const statut= ref(0);
    const personnelOptions = ref();
    const produitsData=ref([]);
    const isDisables = ref(true);
    const isDis =  ref(true);
    const dateDebut =  ref(new Date().toISOString().slice(0, 16));
    const  dateFin = ref(new Date().toISOString().slice(0, 16));
    const disabledButom = ref(true);
    disabledButom.value = (typeInventaire.value == 'Partiel')? isDisable.value:isDisables.value ; 
    
    isDis.value = (magasin.value)? false:true;
    const equipes = reactive([]);

    const addRowEquipe = () => {
      equipes.push({
        id:"",
        role: "",
        user:""
      });
    };

    const removeRowEquipe = async (index) => {
      const id = equipes[index].id as number;
      if (id) {
        await suppression(id,equipes,'user/equipe','l\'équipe');
      }else{
        equipes.splice(index,1)
      }
    };

    watch(
      equipes,
      (newValue) => {
        isDisables.value =
        newValue.some(
          (equipe) =>
          valideteRowEquipe(equipe.role) ||
          valideteRowEquipe(equipe.user) || validateDupliacatEquipe(equipe.user)
        );
        disabledButom.value = (typeInventaire.value == 'Partiel')? isDisable.value:isDisables.value ; 
      },
      { deep: true }
    );

    const valideteRowEquipe = (e) => {
      if (e == "" || e == "" || e == "" || e == 0 || e == "0" || e == null || e < 0) {
        console.log('erg')
        return true;
      } else {
        return false;
      }
    };

    const getAllPersonnels = async () => {
      try{
        const response = await ApiService.get('/all/users');
        const canalsData = response.data.data;
        console.log('DataDataData',canalsData)
        personnelOptions.value = canalsData.map((personnel) => ({
          value:personnel.id,
          label:personnel.nom + " " + personnel.prenom ,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const getAllRoles = async () => {
      try{
      const response = await ApiService.get('/roles');
      const rolesData = response.data.data;
      console.log('Data',rolesData)
      roleOptions.value = rolesData.map((role) => ({
        value:role.id,
        label:role.nom,
      }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const magasinsss: any = ref(null);
    const valuess = ref();

    const fetchMagasins = async () => {
      try {
        const response = await axios.get("/all/all/magasins");
        const magasinsData = response.data.data;
        magasinsss.value = magasinsData;
        magasinOptions.value = magasinsData.map((magasin) => ({
          value: magasin.id + "|" + magasin.nomMagasin,
          label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      } catch (error) {
        //
      }
    };

    const fetchInventaire = async () => {
      try {
        const response = await axios.get("/inventaires/type/Global");
        const invData = response.data.data;
        inventaireOptions.value = invData.map((inv) => ({
          value: inv.id + "|" + inv.refInventaire,
          label: `${inv.refInventaire}`,
        }));

        console.log("inventaireOptions.valueinventaireOptions.value ==> 0",inventaireOptions.value)
      } catch (error) {
        //
      }
    };

    // const EditeInventaire = async () => {
    //   const values = {
    //     inventaiprocondimags:produits,
    //   }
    //   ApiService.put("/inventaires/"+inventaire.value, values)
    //     .then(({ data }) => {
    //       if (data.code == 200) {
    //         success(data.message);
    //         router.push({ name: "ListeInventaire" });
    //       }
    //     })
    //     .catch(({ response }) => {
    //       error(response.data.message);
    //     });
    // };

    async function getAllInventaireById(id) {
     await  ApiService.get(`/inventaires/`+id)
          .then(({ data }) => {
            for (const key in data.data) {
            inventaireForm.value?.setFieldValue(key, 
            (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
          );}
           // magasinss.value = data.data.magasin.nomMagasin;
           console.log(data,"data.data.");
            console.log(data.data.inventaiprocondimags,"data.data.inventaiprocondimags");
            typeInventaire.value = data.data.typeInventaire;
            magasin.value= data.data.magasin.id+ "|" + data.data.magasin.nomMagasin;
            motif.value= data.data.motif;
            
            dateDebut.value= data.data.dateDebut.slice(0, 16);
            dateFin.value= data.data.dateFin.slice(0, 16);

          console.log( dateFin.value, "data.data.dateDebut.slice(0, 16)", dateDebut.value)
            //inventaireGlobal.value=data.data.inventaireGlobal.id;
            data.data.equipes.forEach(equipe => {
              equipes.push({
              id: equipe.id,
              user:equipe.user.id,
              role: equipe.role.id,
            })});
            
            data.data.inventaiprocondimags.forEach(produit => {
            produits.push({
              id: produit.id,
              produit:produit.procondimag.produitcondi.id +'|'+ produit.nomProd,
              qtiteLogique: produit.qteLogique,
              qtiteFiche: produit.qteFiche,
            })});
            console.log("produits",produits);
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
    }

    const fetchDataOption = async () => {
      produitOptions.value = produitsData.value.map((produit) => ({
          value: produit.id +'|'+`${produit.produit.codeProduit} - ${produit.produit.nomProd} [${produit.conditionnement.libelle}]`,
          label: `${produit.produit.codeProduit} - ${produit.produit.nomProd} [${produit.conditionnement.libelle}]`,
      }));
    }

    const fetchProduits = async () => {
      try {
        //const response = await axios.get("/all/produitconditionnementmagasins/"+magasin);
        const response = await axios.get("/all/produitconditionnements/");
        produitsData.value = response.data.data;
        console.log(produitsData,"produitsDataproduitsDataproduitsDataproduitsData");
        fetchDataOption();
        // produitOptions.value = produitsData.map((produit) => ({
        //   value: produit.id,
        //   label: `${produit.produit.refProd} - ${produit.produit.nomProd} [${produit.conditionnement.libelle}]`,
        //   disabled: produits.filter(prod => prod.produit == produit.id)
        // }));
        console.log(produitOptions.value,"response.data.data");
      } catch (error) {
        console.log(error,"errorerrorerror")
      }
    };
    const minDate = ref(new Date().toISOString().slice(0, 16))


    const Soumettre = async()=>{
      Swal.fire({
        text: "Vous êtes sur le point de soumettre la fiche. Etes-vous sûr ?",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Enregistrer et Soumettre",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton:"btn btn-danger"
        },
      }).then(async(result) => {
        try {
          if (result.isConfirmed) {
            statut.value=1;
            if (statut.value==1) {
              submitButton.value.click();
            }
            
          }else{
            error("Vous avez annulé la soumission");
          }
        } catch (response) {
          error(response.message);
        }
      })
    }



    const addInventaire = async (values, { resetForm }) => {
      if(typeInventaire.value=="Partiel"){
        const prod = [];
        produits.forEach(produit => {
          if (produit.id !='') {
            prod.push({
              id:produit.id,
              procondimag: produit.produit.split('|')[0],
              qteLogique: produit.qtiteLogique,
              qteFiche: produit.qtiteFiche,
              nomProd: produit.produit.split('|')[1]
            })
          }else{
            prod.push({
              procondimag: produit.produit.split('|')[0],
              qteLogique: produit.qtiteLogique,
              qteFiche: produit.qtiteFiche,
              nomProd: produit.produit.split('|')[1]
            })
          }
          
        });
        
        values.inventaiprocondimags = prod
        values.magasin = magasin.value.split('|')[0];
        values.inventaireGlobal = values.inventaireGlobal ? (values.inventaireGlobal).split("|")[0] : values.inventaireGlobal;
      }
      values.typeInventaire=typeInventaire.value;
      
      values.equipes = equipes.filter((element) => element.id != "");
       values.equipesNew = equipes.filter((element) => element.id == "").map((equipe) => ({
        role:equipe.role,
        user:equipe.user
       }));
       values.statut = statut.value;
      
      console.log('DOnnées =>', values)
      ApiService.put("/inventaires/fiche/"+route.params.id, values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            console.log(data,"datadatadatadata");
            router.push({ name: "ListeFicheInventaire" });
          }
        })
        .catch(({ response }) => {
          error(response.message);
        });
    };


    return {
      minDate,
      inventaireSchema,
      addInventaire,
      inventaireForm,
      removeRowProduit,
      addRowProduit,
      validateRowProduit,
      validateDupliacatEquipe,
      validateDupliacatProduit,
      produits,
      valuess,
      inventaireOptions,
      inventaireGlobal,
      magasinOptions,
      magasin,
      produitOptions,
      selectProd,
      isDisable,
      isDisables,
      disabledButom,
      isDis,
      dateDebut,
      dateFin,
      motif,
      Soumettre,
      submitButton,
      selectMag,
      valideteRowEquipe,
      addRowEquipe,
      removeRowEquipe,
      equipes,
      typeInventaire,
      personneOptions,
      personnelOptions,
      roleOptions
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
.marge-droite {
  margin-left: 87px;
}
.hr-longeur {
  width: 80%;
}
.bord1 {
  border: 1px solid #07a;
}
.fond {
  background-color: rgb(94, 191, 233);
}
</style>